module.exports = __webpack_public_path__ + "static/media/Facial-paralysis-three@2x.5b4cead5.png";